require("!!/Users/admin/Projects/material-dashboard-angular-master/node_modules/script-loader/addScript.js")(require("!!/Users/admin/Projects/material-dashboard-angular-master/node_modules/raw-loader/index.js!/Users/admin/Projects/material-dashboard-angular-master/node_modules/moment/moment.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/moment/moment.js
// module id = 267
// module chunks = 2